import BaseApiService from './base-api-service';

import { CurrencyModel } from '../models/currency';

export default class CurrencyService extends BaseApiService {
  public async getCurrency(): Promise<CurrencyModel> {
    const response = await this.getResource('/GetCurrencyValute');

    return response;
  }
}
